import React from "react"
import { Link } from "react-router-dom"
import { headerButtonStyle } from "containers/Header/Actions"
import Jumbo from "./Jumbo"
import ActionBarText from "./ActionBarText"
import InfoBar from "./InfoBar"
import HowWeHelp from "./HowWeHelp"
import OtherSites from "./OtherSites"
import glamorous from "glamorous"
import style from "utils/style"

const Home = props => (
  <div>
    <HeaderButtonContainer>
      <HeaderButton to="/camps/new">List Your Camp</HeaderButton>
    </HeaderButtonContainer>
    <Jumbo />
    <ActionBarText
      tint={style.colors.forestGreen}
      route="/camps/new"
      text="List your camp &rarr;"
    />
    <ActionBarText
      tint={style.colors.forestGreen}
      route="/users/sign_up"
      text="Become a camper &rarr;"
    />
    <InfoBar />
    <Divider />
    <HowWeHelp />
    <Divider />
    <OtherSites />
  </div>
)

const Divider = glamorous.div({
  borderBottom: `1px solid ${style.colors.altVeryLightGray}`,
  margin: "auto",
  width: "80%",
})

const HeaderButtonContainer = glamorous.div({
  display: "flex",
  justifyContent: "center",
  position: "absolute",
  width: "100%",
  marginTop: "1rem",
  zIndex: 2,
})

const HeaderButton = glamorous(Link)({
  ...headerButtonStyle,
  "@media(min-width: 451px)": {
    display: "none",
  },
})

export default Home



// WEBPACK FOOTER //
// ./src/scenes/Home/index.js